import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Map, List } from 'immutable';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as targetActions from 'modules/target';

import { AdminTargetDelete } from 'components';

class CtAdminTargetDelete extends Component {
  constructor(props) {
    super(props);

    this.state = {
      deleting: false
    };
  }

  removeTarget = async () => {
    this.setState({ deleting: true });

    const { mountDeleteModal, targetInfo: { targetNo } } = this.props;

    const params = {};
    let isOk = true;
    if (targetNo) {
      params.targetNo = targetNo;
    } else {
      // 오류
      isOk = false;
    }

    if (isOk) {
      try {
        const { TargetActions } = this.props;
        await TargetActions.deleteTarget(params);
      } catch (e) {
        console.log(e);
      }
    } else {
      console.log('removeTarget isOk fail!');
    }

    mountDeleteModal();
  };

  render() {
    const { deleting } = this.state;
    const { targetInfo, mountDeleteModal } = this.props;
    const { removeTarget, handleOnToggleDeleteModal } = this;

    return (
      <AdminTargetDelete
        deleting={deleting}
        targetInfo={targetInfo}
        removeTarget={removeTarget}
        handleOnToggleDeleteModal={mountDeleteModal}
      />
    );
  }
}

CtAdminTargetDelete.propTypes = {};
CtAdminTargetDelete.defaultProps = {};

const mapDispatchToProps = dispatch => ({
  TargetActions: bindActionCreators(targetActions, dispatch)
});

export default connect(undefined, mapDispatchToProps)(CtAdminTargetDelete);



// WEBPACK FOOTER //
// ./src/script/containers/admin/target/CtAdminTargetDelete.js